module.exports = __webpack_public_path__ + "img/set_theme_4.de5c58d5.png";